import { service } from 'Services/api/api.service';
import { PreviousYearsServiceType } from './types';

const PreviousYearsService: PreviousYearsServiceType = {
  getPreviousYearUser: () => service.patch(`/previous-years-analysis/request`),
  getUserRequestPreviousYear: () => service.get(`/previous-years-analysis`),
};

export default PreviousYearsService;
